import React, { useState, useEffect } from 'react'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import Layout from '../../../../brands/components/Layout'
import './index.css'
import UploadFormModal from '../../component/UploadFormModal'
import {
    loadFormAssignedToMe,
    downloadForm,
    submitForm,
    downloadUploadedForm,
} from '../../../api'
import {
    HIDE_LOADER,
    SHOW_LOADER,
} from '../../../../../redux/slices/LoaderSlice'
import { useAppDispatch, useAppSelector } from '../../../../../redux/hook'
import { formatDateAndTime } from '../../../../resources/empresources/utils'
import { saveFormList, updateFormStatus } from '../../../slice/formslice'
import { TeachersFormState } from '../type'
import { SHOW_NOTIFICATION } from '../../../../../redux/slices/showNotificationSlice'

const FormTable: React.FC = () => {
    const [showuploadPopup, setShowUploadPopup] = useState<boolean>(false)
    const [selectedRowId, setSelectedRowId] = useState<string>('')
    const formData = useAppSelector(
        (state: TeachersFormState) => state.forms.formList
    )

    const userId = useAppSelector(
        (state: any) => state.persistedReducers.user.id
    )

    const dispatch = useAppDispatch()
    const loadForms = async () => {
        dispatch(SHOW_LOADER())
        const response = await loadFormAssignedToMe()
        response?.data?.data?.sort(
            (a: { assignedOn: string }, b: { assignedOn: string }) =>
                new Date(b.assignedOn).getTime() -
                new Date(a.assignedOn).getTime()
        )
        const forms = response?.data?.data.map((form: any) => {
            return {
                title: form.title,
                assignedOn: formatDateAndTime(form.assignedOn),
                uploadedOn: formatDateAndTime(form.uploadedOn),
                status: form.status,
                id: form.id,
                formId: form.formId,
            }
        })
        dispatch(saveFormList({ data: forms }))
        dispatch(HIDE_LOADER())
    }

    useEffect(() => {
        loadForms()
    }, [])

    const documentSumbit = async (file: any) => {
        dispatch(SHOW_LOADER())
        const res = await submitForm(file, selectedRowId)
        if (res.data) {
            dispatch(updateFormStatus({ id: selectedRowId }))
            dispatch(
                SHOW_NOTIFICATION({
                    message: 'Successfully uploaded the form',
                    type: 'success',
                })
            )
        }
        dispatch(HIDE_LOADER())
    }

    const downlaodForm = async (id: string) => {
        try {
            const link = await downloadForm(id)
            const anchor = document.createElement('a')
            anchor.href = link.data
            anchor.target = '_blank'
            anchor.setAttribute('download', '')
            document.body.appendChild(anchor)
            anchor.click()
            document.body.removeChild(anchor)
        } catch (error) {
            console.error('Error downloading form:', error)
        }
    }

    const downlaodUploadedForm = async (id: string, formId: string) => {
        dispatch(SHOW_LOADER())
        try {
            const link = await downloadUploadedForm(id, formId)
            const anchor = document.createElement('a')
            anchor.href = link.data
            anchor.target = '_blank'
            anchor.rel = 'noopener noreferrer'
            anchor.setAttribute('download', '')
            document.body.appendChild(anchor)
            anchor.click()
            document.body.removeChild(anchor)
        } catch (error) {
            console.error('Error downloading form:', error)
        } finally {
            dispatch(HIDE_LOADER())
        }
    }

    const column = [
        {
            key: 'title',
            name: 'Name',
            resizable: true,
            sortable: true,
            // flexGrow: 3,
        },
        {
            key: 'status',
            name: 'Status',
            resizable: true,
            sortable: true,
            width: 200,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending'
                                ? 'status'
                                : props.row.status === 'Completed'
                                  ? 'appr'
                                  : 'rej'
                        }
                    >
                        {props.row.status === 'Pending' ? (
                            <Icon
                                icon="material-symbols:circle-outline"
                                color="#195AA7"
                                fontSize={'20px'}
                            />
                        ) : (
                            <Icon
                                icon="teenyicons:tick-circle-solid"
                                color="#11A030"
                                fontSize={'20px'}
                            />
                        )}
                        <span className="ms-2">{props.row.status}</span>
                    </div>
                )
            },
        },
        {
            key: 'assignedOn',
            name: 'Assigned On',
            resizable: true,
            sortable: true,
            width: 200,
        },
        {
            key: 'uploadedOn',
            name: 'Uploaded On',
            resizable: true,
            sortable: true,
            width: 200,
        },
        {
            key: 'actions',
            name: 'Actions', // Fix the typo here
            resizable: true,
            width: 200,
            renderCell: (props: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            icon="material-symbols:download"
                            color="#39877C"
                            className="pointer"
                            onClick={(e) => {
                                e.preventDefault()
                                downlaodForm(props.row.formId)
                            }}
                        />
                        <Icon
                            icon="iwwa:upload"
                            color="black"
                            className="pointer strock-black"
                            onClick={() => {
                                setShowUploadPopup(true)
                                setSelectedRowId(props.row.id)
                            }}
                        />
                        {props.row.status === 'Completed' && (
                            <div className="custom-btn">
                                <button
                                    className="button button-primary me-5"
                                    type="button"
                                    onClick={() =>
                                        downlaodUploadedForm(
                                            userId,
                                            props.row.formId
                                        )
                                    }
                                >
                                    View
                                </button>
                            </div>
                        )}
                    </div>
                </>
            ),
        },
    ]

    return (
        <div>
            <UploadFormModal
                show={showuploadPopup}
                onClose={setShowUploadPopup}
                callBack={(file: any) => {
                    documentSumbit(file)
                    setShowUploadPopup(false)
                }}
            />
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>Forms</h4>
                            </div>
                        </div>
                    </div>

                    <>
                        <DataGrid
                            className="data-grid-table"
                            columns={column}
                            rows={formData}
                            rowHeight={60}
                            headerRowHeight={40}
                        />
                    </>
                </div>
            </Layout>
        </div>
    )
}

export default FormTable
